const carouselData = [
  {
    title: '2024年度十大塌房事件盘点',
    desc: '从顶流艺人到头部网红，那些曾经光鲜亮丽的公众人物如何在24小时内从天堂坠入地狱。',
    cover: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20composition%20showing%20falling%20puzzle%20pieces%20against%20dark%20crimson%20background%2C%20symbolic%20representation%20of%20collapsing%20reputation%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20magazine%20cover%20style%20photography%2C%20sophisticated%20atmospheric%20mood&width=1200&height=600&seq=carousel-01&orientation=landscape',
    tag: '年度盘点',
    count: '12篇',
  },
  {
    title: '娱乐圈潜规则深度调查报道',
    desc: '多位圈内人士匿名爆料，揭开选角、签约、资源分配背后的不为人知的黑暗面。',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20investigative%20atmosphere%20with%20silhouetted%20figures%20behind%20frosted%20glass%2C%20anonymous%20interview%20setting%2C%20dramatic%20contrast%20lighting%2C%20documentary%20film%20noir%20style%2C%20warm%20amber%20and%20deep%20shadow%20composition&width=1200&height=600&seq=carousel-02&orientation=landscape',
    tag: '深度调查',
    count: '8篇',
  },
  {
    title: '直播带货翻车名场面TOP20',
    desc: '从虚假宣传到产品质量问题，那些在直播间里上演的翻车大戏，每一个都堪称经典。',
    cover: 'https://readdy.ai/api/search-image?query=Colorful%20streaming%20studio%20background%20with%20dramatic%20red%20alert%20overlay%2C%20live%20commerce%20broadcast%20aesthetic%20with%20glitch%20effects%2C%20dynamic%20visual%20representing%20broadcast%20failure%2C%20pop%20art%20inspired%20composition%20with%20warm%20vibrant%20colors&width=1200&height=600&seq=carousel-03&orientation=landscape',
    tag: '经典回顾',
    count: '20篇',
  },
  {
    title: '网红圈生态链完整揭秘',
    desc: '从MCN机构运作模式到刷量灰色产业链，一次性讲透你关注的网红背后的真实世界。',
    cover: 'https://readdy.ai/api/search-image?query=Abstract%20network%20diagram%20with%20interconnected%20nodes%20against%20warm%20dark%20background%2C%20digital%20ecosystem%20visualization%2C%20complex%20web%20of%20connections%20in%20amber%20and%20crimson%20tones%2C%20tech%20investigative%20aesthetic%2C%20sophisticated%20data%20art&width=1200&height=600&seq=carousel-04&orientation=landscape',
    tag: '行业揭秘',
    count: '15篇',
  },
  {
    title: '饭圈文化演变史：从应援到互撕',
    desc: '深度梳理十年饭圈文化变迁，从温暖应援到极端对立，谁在推波助澜这场永不落幕的战争。',
    cover: 'https://readdy.ai/api/search-image?query=Crowd%20of%20anonymous%20silhouettes%20with%20glowing%20phone%20screens%20in%20darkness%2C%20fan%20culture%20aesthetic%2C%20dramatic%20stadium%20lighting%20atmosphere%2C%20ocean%20of%20light%20sticks%2C%20editorial%20documentary%20style%20photography%20with%20warm%20and%20cool%20contrast&width=1200&height=600&seq=carousel-05&orientation=landscape',
    tag: '文化观察',
    count: '10篇',
  },
];

export default function SectionCarousel() {
  return (
    <section id="carousel" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            焦点专题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            深度策划，带你全面了解每一个热点事件
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselData.map((item, idx) => (
            <div
              key={idx}
              className={`bg-background-50 rounded-2xl overflow-hidden cursor-pointer group hover:shadow-md transition-shadow duration-300 ${
                idx === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${idx === 0 ? 'aspect-[2/1] lg:aspect-auto lg:h-[340px]' : 'aspect-video'}`}>
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-600"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="text-xs px-2.5 py-1 rounded-full bg-accent-500 text-background-50 font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-background-50/80 bg-black/40 px-2 py-1 rounded-full whitespace-nowrap">
                    {item.count}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className={`font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2 ${
                  idx === 0 ? 'text-lg md:text-xl' : 'text-base'
                }`}>
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 mt-2 line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}